module.exports = __webpack_public_path__ + "img/logo-white.6a858613.png";